"use client";

import {Image, Flex, SimpleGrid, Stack, StackProps} from "@chakra-ui/react";
import NextImage from "next/image";

import {HoverMenuItem, HoverMenuItemHeading, HoverMenuItemText, HoverMenuList} from "../components/HoverMenu";
import Loading from "../../Loading";
import query from "../../../app/utils/query";
import {useEffect, useState} from "react";

type NavBarTestimonial = {
  title: string;
  navLogo: {url: string; width: number; height: number};
  navDescription: string;
  navColour: string;
  id: string;
  blogPost: {slug: string};
  author: {name: string; avatar: {url: string}; jobTitle: string};
};

const QUERY = `{
  caseStudies(where: {showInNav: true}, {STAGE}) {
    id
    title
    author {name avatar {url} jobTitle}
    navLogo {url, width, height}
    navColour
    navDescription
    blogPost {slug}
  }
}`;

const Customers = (props: StackProps) => {
  const [testimonials, setTestimonials] = useState<NavBarTestimonial[] | null>(null);

  useEffect(() => {
    async function fetchTestimonials() {
      const resp = await query(QUERY);
      const data = await resp.json();
      setTestimonials(data.data.caseStudies as NavBarTestimonial[]);
    }
    fetchTestimonials();
  }, []);

  return (
    <HoverMenuList {...props}>
      <SimpleGrid gap={6}>
        {!testimonials ? (
          <Loading />
        ) : (
          testimonials.map((t, i) => (
            <HoverMenuItem px={6} py={2} className="group" key={i}>
              <Flex
                w={10}
                h={10}
                p={2}
                rounded="md"
                flexShrink={0}
                bg="gray.900"
                align="center"
                justify="center"
                border="2px solid"
                borderColor={`${t.navColour}.300`}
              >
                <Image w="full" h="full" asChild alt="">
                  <NextImage width={t.navLogo.width} height={t.navLogo.height} src={t.navLogo.url} alt="" />
                </Image>
              </Flex>
              <Stack gap={1}>
                <HoverMenuItemHeading to={`/blog/${t.blogPost.slug}`}>{t.title}</HoverMenuItemHeading>
                <HoverMenuItemText>{t.navDescription}</HoverMenuItemText>
              </Stack>
            </HoverMenuItem>
          ))
        )}
      </SimpleGrid>
    </HoverMenuList>
  );
};
export default Customers;
